import request from '../../../request/request';
import { retry } from '../../../shared/retry';

function loadResources(url) {
	// add reload capability since resource are essential for initial eval component load, failure causes error boundary condition.
	return retry(
		() => request({ url, method: 'GET', withCredentials: false, accept: 'json' }).then(({ body }) => body),
		{
			retries: 3,
			delay: 500,
			onRetry: (error, attempt) => {
				// eslint-disable-next-line no-console
				console.warn(`Retrying loadResources fn load (attempt ${attempt}):`, url, error);
			}
		}
	);
}

export default loadResources;
